import { useQuery } from '@tanstack/react-query';
import fetchData from '../fetcher';
import type { GetOrganizationByIdResponse, IamOrganizationDetail } from './types';

export const unwrapOrganization = (
  response: GetOrganizationByIdResponse | null | undefined
): IamOrganizationDetail | null => {
  if (!response) return null;
  if (response.data?.itemId) return response.data;
  if (response.organization?.itemId) return response.organization;
  if (response.itemId) return response;
  return null;
};

export const fetchOrganizationById = async (organizationId: string) => {
  const response = await fetchData<GetOrganizationByIdResponse>(
    `/iam/v4/iam/organizations/${organizationId}`,
    {
      method: 'GET',
      credentials: 'include',
    }
  );
  return unwrapOrganization(response);
};

export const useGetOrganizationById = (organizationId?: string | null) => {
  return useQuery({
    queryKey: ['get-organization-by-id', organizationId],
    queryFn: () => {
      if (!organizationId) {
        throw new Error('organizationId is required');
      }
      return fetchOrganizationById(organizationId);
    },
    enabled: !!organizationId,
  });
};
